'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const IncidentViewModel=require('../../../../../../dist-es6/client/viewModels/incidentViewModel');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const SortExtensions=require('../../../../../../dist-es6/client/extensions/sortExtensions');
const StatisticsPanelHelpers=require('../../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

IncidentsScheduleDirective=function(_BaseControllerBacked){_inherits(IncidentsScheduleDirective,_BaseControllerBacked);function IncidentsScheduleDirective(){_classCallCheck(this,IncidentsScheduleDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(IncidentsScheduleDirective,[{key:'objectBindings',get:function()
{
return[
'multiViewParent',
'personalSchedule',
'groupMemberships',
'homeTimezone',
'fatigueThreshold',
'deviationThreshold',
'personInfo'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/personalSchedule/components/incidentsSchedule/incidentsScheduleView';
}},{key:'controller',get:function()

{
return IncidentsScheduleDirectiveController;
}}]);return IncidentsScheduleDirective}(BaseControllerBackedDirective);let


IncidentsScheduleDirectiveController=function(){
function IncidentsScheduleDirectiveController($state,$scope,$timeout,$element,elementService,intervalService,timeZoneService,personalIncidentsService,displaySettingsService){_classCallCheck(this,IncidentsScheduleDirectiveController);
this._$state=$state;
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
this._elementService=elementService;
this._intervalService=intervalService;
this._timeZoneService=timeZoneService;
this._personalIncidentsService=personalIncidentsService;

this._use24HourTimeline=displaySettingsService.use24HourTimeline;

this.getDateStringFor=this.getDateStringFor.bind(this);
this.getTimeStringFor=this.getTimeStringFor.bind(this);
this.sortByTimeOfDay=this.sortByTimeOfDay.bind(this);
this._sortByDescendingFatigueScore=SortExtensions(this.sortByFatigueScore).invert();
this._sortByDescendingUnixTime=SortExtensions(this.sortByUnixTime).invert();
this.statisticsPanelDimensions=StatisticsPanelHelpers.MinimumStatisticsPanelDimensions;

this.tableColumnDefinitions=[{
label:'Date',
defaultAscending:!1,
orderBy:[this.sortByUnixTime],
columnClass:'date-column',
finalSort:[this._sortByDescendingFatigueScore],
isInitiallyActive:!0},
{
label:'Time',
defaultAscending:!0,
orderBy:[this.sortByTimeOfDay],
finalSort:['description'],
columnClass:'time-column'},
{
label:'Type',
defaultAscending:!0,
orderBy:['description'],
finalSort:[this._sortByDescendingFatigueScore,this._sortByDescendingUnixTime],
columnClass:'type-column'},
{
label:'Fatigue at Time of Incident',
defaultAscending:!1,
orderBy:[this.sortByFatigueScore],
finalSort:[this._sortByDescendingUnixTime],
columnClass:'fatigue-column'}];


this._loadIncidents();
}IncidentsScheduleDirectiveController.prototype.





_loadIncidents=function(){var ref=_asyncToGenerator(function*(){var _this2=this;
const{incidents:incidents,incidentTypes:incidentTypes,dayOfLastPurgedIncident:dayOfLastPurgedIncident}=yield this._personalIncidentsService.getAllIncidentsFor(this.personId);

const validIncidentInterval=this._intervalService.getMonthlyLookbackIntervalIncludingCurrentDayFor(this.homeTimezone,StatisticsPanelHelpers.TotalMonthsToDisplayInGraph);

const{
filteredIncidents:filteredIncidents,
finalIncidentBeforeInterval:finalIncidentBeforeInterval}=
StatisticsPanelHelpers.filterSortedIncidentsToIntervalPlusOneBefore(incidents,validIncidentInterval);

const daysSinceLastIncidentPathStartTime=StatisticsPanelHelpers.getPathStartTimeForDaysSinceGraph(
_.get(finalIncidentBeforeInterval,'time'),
_.exists(dayOfLastPurgedIncident)?dayOfLastPurgedIncident.startOfDayInTimezone(this.homeTimezone):null,
_.get(this.personalSchedule,'bounds.start'),
this.personInfo.creationTime);

const incidentViewModels=filteredIncidents.map(function(i){return IncidentViewModel.createFrom(i,{code:i.code,description:i.description},_this2.timezone,_.noop)});
for(const ivm of incidentViewModels){
ivm.currentlyScopedGroupMemberships=this.groupMemberships;
}

this._$timeout(function(){
_this2._incidents=incidentViewModels;
_this2._incidentTypes=incidentTypes;
_this2._incidentInterval=validIncidentInterval;
_this2._daysSinceLastIncidentPathStartTime=daysSinceLastIncidentPathStartTime;
});
});function _loadIncidents(){return ref.apply(this,arguments)}return _loadIncidents}();IncidentsScheduleDirectiveController.prototype.








goToIncident=function(){var ref=_asyncToGenerator(function*(incident){
yield this._$state.go('fdc.features.personalSchedule',{
interval:TimeInterval.fromPoint(incident.time),
personalScheduleTabSelection:-1});

});function goToIncident(incident){return ref.apply(this,arguments)}return goToIncident}();IncidentsScheduleDirectiveController.prototype.

getDateStringFor=function getDateStringFor(item){
const dayOfWeek=Formatters.dayOfWeekInTimeZone(item.time,this.homeTimezone).toUpperCase();
const monthDayYear=Formatters.formatInLocale(item.time,'MMM DD, YYYY',this.homeTimezone,{displayTimeZone:!1});

return`${dayOfWeek} ${monthDayYear}`;
};IncidentsScheduleDirectiveController.prototype.

getTimeStringFor=function getTimeStringFor(item){
return Formatters.timeInLocale(item.time,this.homeTimezone,!1,this._use24HourTimeline);
};IncidentsScheduleDirectiveController.prototype.

sortByUnixTime=function sortByUnixTime(item){
return item.time.getTime();
};IncidentsScheduleDirectiveController.prototype.

sortByFatigueScore=function sortByFatigueScore(item){
return Math.floor(item.fatigue)||Number.NEGATIVE_INFINITY;
};IncidentsScheduleDirectiveController.prototype.

sortByTimeOfDay=function sortByTimeOfDay(item){
return parseInt(Formatters.formatInLocale(item.time,`HHmm`,this.timezone),10);
};IncidentsScheduleDirectiveController.prototype.

_getFatigueThresholdStatusFor=function _getFatigueThresholdStatusFor(incident){
return ThresholdStatus.fromScoreAndThreshold(incident.fatigue,this.fatigueThreshold);
};IncidentsScheduleDirectiveController.prototype.

_getDeviationThresholdStatusFor=function _getDeviationThresholdStatusFor(incident){
const fatigueHistory=_.get(incident.statistics,'recentHistory.fatigue');
const effectiveDeviationThreshold=ThresholdStatus.getEffectiveDeviationThresholdFrom(fatigueHistory,this.deviationThreshold);
return ThresholdStatus.fromScoreAndThreshold(incident.fatigue,effectiveDeviationThreshold);
};IncidentsScheduleDirectiveController.prototype.

_getDeviationFor=function _getDeviationFor(incident){
const fatigueHistory=_.get(incident.statistics,'recentHistory.fatigue');
const effectiveDeviationThreshold=ThresholdStatus.getEffectiveDeviationThresholdFrom(fatigueHistory,this.deviationThreshold);
return ThresholdStatus.getDeviationFromEffectiveThreshold(incident.fatigue,effectiveDeviationThreshold);
};_createClass(IncidentsScheduleDirectiveController,[{key:'directiveElement',get:function(){return this._directiveElement||(this._directiveElement=this._elementService.selectElement('.current-view')[0])}},{key:'displayStatisticsPanels',get:function(){return _.exists(this.incidentInterval)&&_.exists(this.filteredIncidents)&&_.get(this.incidentTypes,'length')>0&&(_.get(this.filteredIncidents,'length')>0||_.get(this.searchQuery,'length')===0)}},{key:'incidents',get:function()

{
return this._incidents;
}},{key:'incidentInterval',get:function()

{
return this._incidentInterval;
}},{key:'incidentTypes',get:function()

{
return this._incidentTypes;
}},{key:'daysSinceLastIncidentPathStartTime',get:function()

{
return this._daysSinceLastIncidentPathStartTime;
}},{key:'timezone',get:function()

{
return this._$state.params.timezone;
}},{key:'interval',get:function()

{
return this._$state.params.interval;
}},{key:'personId',get:function()

{
return this._$state.params.id;
}}]);return IncidentsScheduleDirectiveController}();


module.exports=IncidentsScheduleDirective;
//# sourceMappingURL=incidentsScheduleDirective.js.map
